import { useState, useEffect } from "react";
import { Mail, Phone, MessageCircle } from "lucide-react";
import api from "@/lib/api";

const INSTRUCTOR_PHOTO = "https://customer-assets.emergentagent.com/job_1791f9d8-ffce-4632-931c-e01b5c5c94c3/artifacts/fn2eo02h_1000003634.jpg";

export default function HelpPage() {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch((err) => console.error(err));
  }, []);

  return (
    <div className="page-with-nav bg-white min-h-screen" data-testid="help-page">
      <div className="px-4 pt-4 pb-6">
        <h1 className="text-xl font-black text-slate-900" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
          Help & Support
        </h1>
        <p className="text-sm text-slate-500 mt-1">We're here to help you succeed!</p>
      </div>

      {/* Instructor Card */}
      <div className="mx-4 bg-slate-50 p-6 flex items-center gap-4 mb-6">
        <img src={INSTRUCTOR_PHOTO} alt="Instructor" className="w-16 h-16 object-cover" />
        <div>
          <p className="font-bold text-slate-900">Smart English Fast English</p>
          <p className="text-xs text-slate-500 mt-0.5">Your Instructor & Guide</p>
        </div>
      </div>

      {/* Contact Info */}
      <div className="px-4 space-y-3">
        <div className="bg-slate-50 p-4 flex items-center gap-4">
          <div className="w-10 h-10 bg-[#0284C7] text-white flex items-center justify-center flex-shrink-0">
            <Mail size={18} />
          </div>
          <div>
            <p className="text-xs font-bold text-slate-500 uppercase">Email</p>
            <p className="text-sm font-medium text-slate-900">
              {settings.support_email || "support@smartenglishfastenglish.com"}
            </p>
          </div>
        </div>

        <div className="bg-slate-50 p-4 flex items-center gap-4">
          <div className="w-10 h-10 bg-[#0284C7] text-white flex items-center justify-center flex-shrink-0">
            <Phone size={18} />
          </div>
          <div>
            <p className="text-xs font-bold text-slate-500 uppercase">Phone</p>
            <p className="text-sm font-medium text-slate-900">
              {settings.support_phone || "+91-9000000000"}
            </p>
          </div>
        </div>

        <div className="bg-slate-50 p-4 flex items-center gap-4">
          <div className="w-10 h-10 bg-green-600 text-white flex items-center justify-center flex-shrink-0">
            <MessageCircle size={18} />
          </div>
          <div>
            <p className="text-xs font-bold text-slate-500 uppercase">WhatsApp</p>
            <p className="text-sm font-medium text-slate-900">
              {settings.support_phone || "+91-9000000000"}
            </p>
          </div>
        </div>
      </div>

      {/* FAQ */}
      <div className="px-4 mt-8 pb-8">
        <h2 className="text-base font-bold text-slate-900 mb-3" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
          Frequently Asked Questions
        </h2>
        <div className="space-y-2">
          {[
            { q: "How do I access my purchased courses?", a: "Go to 'My Courses' from the bottom navigation. All your purchased courses will be listed there." },
            { q: "What payment methods are accepted?", a: "We accept UPI, Debit/Credit Cards, Net Banking, and Wallets through Razorpay." },
            { q: "Can I watch courses offline?", a: "Currently, courses are available for online streaming only." },
            { q: "How long do I have access to a course?", a: "Once purchased, you have lifetime access to the course content." },
          ].map((faq) => (
            <details key={faq.q} className="bg-slate-50 group">
              <summary className="px-4 py-3 text-sm font-medium text-slate-900 cursor-pointer list-none flex items-center justify-between">
                {faq.q}
                <ChevronIcon />
              </summary>
              <p className="px-4 pb-3 text-xs text-slate-600 leading-relaxed">{faq.a}</p>
            </details>
          ))}
        </div>
      </div>
    </div>
  );
}

function ChevronIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-slate-400">
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
}
